<div class="checkout-page container-v2">
  <sd-checkout-header class="checkout-page__header">
    <sd-heading></sd-heading>
  </sd-checkout-header>

  <div class="checkout-page__main">
    <sd-switch-profile></sd-switch-profile>
    <sd-receipt></sd-receipt>
    <sd-payment-modes></sd-payment-modes>
    <sd-contacts></sd-contacts>
  </div>

  <div class="checkout-page__sidebar">
    <sd-checkout-order-summary></sd-checkout-order-summary>
  </div>
</div>
